import { getDeviceTypesApi, getFirmwaresApi, getRescueApi } from '@services/api/configuration';
import {
  CreateRescueRequest,
  ReadFirmwaresForRescueRequest,
  ReadRescueByIdRequest,
  UpdateRescueRequest,
} from '@openapi';

const rescue = {
  getRescue: () => {
    return getRescueApi().getRescues();
  },
  getRescueById: (id: ReadRescueByIdRequest['id']) => {
    return getRescueApi().readRescueById({ id: id });
  },
  updateRescue: (updateRescueRequest: UpdateRescueRequest) => {
    return getRescueApi().updateRescueFirmware({ updateRescueRequest: updateRescueRequest });
  },
  createRescue: (createRescueRequest: CreateRescueRequest) => {
    return getRescueApi().createRescueFirmware({ createRescueRequest: createRescueRequest });
  },
  getFirmwareRescue: (requestParameters: ReadFirmwaresForRescueRequest) => {
    return getFirmwaresApi().readFirmwaresForRescue(requestParameters);
  },
  getDeviceRescue: () => {
    return getDeviceTypesApi().readRescueDeviceTypes();
  },
};

export default rescue;
